import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { emailReducer } from 'reducers/emailReducer';

export const EmailContext = createContext({ emails: [] });

const EmailProvider = ({ children }) => {
  const [emailState, emailDispatch] = useReducer(emailReducer, {
    // Inbox emails (not used; no-reply sender)
    emails: [],
    allEmails: [],
    filters: ['all', 'unread', 'star', 'attachments', 'archive', 'snooze'],
    currentFilter: 'all',

    // Sent emails (array; populated when user sends or when fetched from API)
    sentEmails: [],
    allSentEmails: [],
    currentSentFilter: 'all',

    // Users for recipient selection
    users: [],

    // UI state
    loading: false,
    error: null,
  });

  return (
    <EmailContext.Provider value={{ emailState, emailDispatch }}>
      {children}
    </EmailContext.Provider>
  );
};

EmailProvider.propTypes = { children: PropTypes.node };

export const useEmailContext = () => useContext(EmailContext);

export default EmailProvider;
